/**
 * Template: Blog.Masonry
 * -----------------------------------------------------------------------------
 * Styles for blog.masonry template.
 *
 */

import '@/templates/blog-masonry.scss'

/**
 * Components.
 */
import BlogFilters from '~/components/blog-filters'

document.addEventListener('DOMContentLoaded', () => {
  BlogFilters().init()
})
